import styled from "styled-components";
import { DatePicker, Button, Select, Upload, Radio, Card } from "antd";

export const XCalendar = styled(DatePicker)`
  width: 100%;
  height: 40px;
  margin-top: 20px;
  input {
    pointer-events: none;
  }
`;
export const XSubmit = styled(Button)`
  position: absolute;
  right: 10px;
  border-radius: 7px !important;
`;
export const SelectBox = styled(Select)`
  font-size: 14px;
  div.ant-select-selector {
    border-radius: 7px !important;
  }
`;
export const UploadBox = styled(Upload)`
  /* font-size:14px;
    div.ant-select-selector{
        border-radius:7px !important;
    } */
  .ant-upload-picture-card-wrapper {
    width: 100%;
  }
  .ant-upload.ant-upload-select-picture-card {
    width: 100%;
    height: 167px;
    box-shadow: 0px 4px 10px rgb(0 0 0 / 3%);
    border-radius: 10px;
  }
`;
export const RadioButton = styled(Radio.Button)`
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  width: 183px;
  padding:0px;
  margin-right: 1%;
  margin-bottom: 2%;
  color:rgba(0, 0, 0, 0.85);
  border-radius: 10px !important;
  border-left-width: 1.02px;
  font-weight: 400;
  border: 1px solid #f0f0f0;
  font-size:15px !important;
  text-align: center;
  height: 40px;
  :not(:first-child)::before {
    height: 0px;
    top: 4px;
  }
  :hover{
    border-color: #883DA9;
    color:#883DA9;
  }
  :active{
    border-color: #883DA9;
    color:#883DA9;
  }
`;
export const RightCard = styled(Card)`
 border-color: transparent;
  box-shadow: 0px 4px 10px rgb(0 0 0 / 3%);
 /* width: 33%; */
  height:100%;
  border-radius: 10px;
  .ant-card-body {
    padding: 21px;
  }
  /* color:#FFFFFF; */
  .ant-card-head{
    border-bottom: none;
  }
  .ant-card-body{
    padding-bottom: 0;
    padding-right: 0;
    padding-left: 0;
  }
  .ant-card-head-title{
    padding: 8px 0px;
    text-wrap: wrap;
    color: ${props => props.theme.colors.primary};
  }
  .ant-card-extra{
    padding: 8px 0px;
  }
`;